import { Icon } from '../types/icons';

export const bottomsIcons: Icon[] = [
	{ key: 'skirt-bottom', url: 'https://cdn.easysize.me/icons/skirt-bottoms.svg' },
	{ key: 'pants-bottom', url: 'https://cdn.easysize.me/icons/pants-bottoms.svg' },
]